import { useScheduledRunTransport } from "../../routes/useScheduledRunsTransport"

interface ScheduledRunBreadcrumbContentProps {
  scheduledRunId: string
  isLast: boolean
}

export function ScheduledRunBreadcrumbContent({
  scheduledRunId,
  isLast,
}: ScheduledRunBreadcrumbContentProps) {
  const { data } = useScheduledRunTransport(scheduledRunId)

  const displayName = data?.scheduled_run.display_name || scheduledRunId

  return <span className={isLast ? "font-semibold" : ""}>{displayName}</span>
}
